import { useNavigate } from 'react-router-dom';
import { CenteredScreen } from '../../components/Screen';
import { useAuth } from './AuthContext';
import { ROUTES } from '../../routes/paths';

/** Shown to blocked/rejected users (feature #3). */
export function BlockedScreen(): JSX.Element {
  const { status, logout } = useAuth();
  const navigate = useNavigate();

  const rejected = status === 'rejected';

  return (
    <CenteredScreen
      title={rejected ? 'Registration not approved' : 'Access blocked'}
      subtitle={
        rejected
          ? 'Your registration request was not approved.'
          : 'Your account access has been suspended.'
      }
    >
      <p className="text-sm text-slate-600">
        Please contact ANYWAY IT SOLUTIONS support if you believe this is a mistake.
      </p>
      <button
        type="button"
        className="btn-secondary mt-5 w-full"
        onClick={async () => {
          await logout();
          navigate(ROUTES.login, { replace: true });
        }}
      >
        Back to login
      </button>
    </CenteredScreen>
  );
}
